import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.replace.js";
import getProperty from "../../helpers/getProperty";
export var borderRegExp = /none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset|thin|medium|thick/;

var borderTransformation = function borderTransformation(property, _ref) {
  var theme = _ref.theme;

  if (typeof property === "number") {
    return "".concat(property).concat(property !== 0 ? "px" : "", " solid");
  }

  if (typeof property === "string") {
    var _property$split$find;

    var color = (_property$split$find = property.split(" ").find(function (chunk) {
      return !borderRegExp.test(chunk) && !/^\d/.test(chunk);
    })) !== null && _property$split$find !== void 0 ? _property$split$find : null;

    if (color) {
      var _map$find;

      var themeValue = (_map$find = ["color", "palette"].map(function (key) {
        return getProperty(theme, "".concat(key, ".").concat(color));
      }).find(Boolean)) !== null && _map$find !== void 0 ? _map$find : null;

      if (!themeValue && ["color", "palette", "palettes"].find(function (key) {
        return color.startsWith(key);
      })) {
        themeValue = getProperty(theme, color);
      }

      if (typeof themeValue === "string") {
        property = property.replace(color, themeValue);
      }
    }
  }

  return String(property);
};

export default borderTransformation;